export enum PaginationChangeType {
    Direct,
    Back,
    Forward
}

export interface IListPagingProps {
    numberOfPages: number;
    activePage: number;
    onChange: (type : PaginationChangeType, key : number) => void;
    showPrevNextMarkers?: boolean;
    maxPageMarkersToShow?: number;
    accessibilityPrefix?: string;
    accessibilitySuffix?: string;
}